export default __webpack_public_path__ + "static/media/exportdoc.20ceb586.svg";